import {InterfaceMedia} from "../../../interface/press-center/interface.media";
import queryString from 'query-string';
import { currentUrl, numberSystemDecimal, searchParams } from '../../../common/consts';

export class MediaPageService {
    private readonly page: number | null;

    constructor(
        private loader: HTMLElement | null,
    ) {
        const urlParams = new URLSearchParams(window.location.search);
        const pageParam = urlParams.get('pageMedia');

        this.page = pageParam ? parseInt(pageParam, numberSystemDecimal) : null;
    }
    async getMedia(): Promise<InterfaceMedia | null> {
        return await this.getMediaByFilterAndPage(this.page);
    }

    async getMediaByPage(page: number | null): Promise<InterfaceMedia | null> {
        return await this.getMediaByFilterAndPage(page);
    }
    async getMediaByFilterAndPage(

        page: number | null,

    ): Promise<InterfaceMedia | null> {
        this.loader?.classList.add('active');

        const queryParams:  Record<string, number | string> = {};

        if (page) {
            searchParams.set('pageMedia', page.toString());
            currentUrl.search = searchParams.toString();
            history.pushState(null, '', currentUrl.toString());
            queryParams.pageMedia = page;
        }

        try {
            const response = await fetch(
                `/api/press-center/media?${queryString.stringify(queryParams)}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': 'true'
                    },
                });
            const data: InterfaceMedia = await response.json();
            this.loader?.classList.remove('active');
            return data;

        } catch (error) {
            this.loader?.classList.remove('active');

            return null;
        }
    }
}
